import bg from "../images/bg.webp";
import FormAtHome from "./FormAtHome";

function HeroSection() {
  return (
    <>
      <div className="relative isolate flex flex-col items-center justify-center px-4 py-24 sm:py-32 h-[700px] lg:h-[650px] bg-[#006039]">
        <img
          src={bg}
          alt="hero"
          className="absolute inset-0 -z-10 h-full w-full object-cover"
        />

        <div className="absolute inset-0 -z-10 bg-black bg-opacity-30" />

        <div className="w-full max-w-7xl mx-auto text-center">
          <div className="mb-8 lg:mb-12 ">
            <h1 className=" text-2xl sm:text-3xl md:text-5xl font-bold mb-3 drop-shadow-lg custom-outline text-scanner">
              FIND YOUR PERFECT RIDE
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-white max-w-lg mx-auto drop-shadow-md">
              Hassle-free Car Rentals with AOMBRE
            </p>
          </div>

          {/* Form */}
          <div className="w-full">
            <FormAtHome />
          </div>
        </div>
      </div>

      {/* --- New Offer Banner --- */}
      <div className="bg-[#006039] py-3 px-4 overflow-hidden border-b border-yellow-500">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-x-3 text-sm sm:text-base font-bold text-white uppercase tracking-wide">
          <span className="flex h-2 w-2 rounded-full bg-red-500 animate-ping"></span>
          <span>We have exciting current offers! To avail them, use the coupon codes given below.</span>
        </div>
      </div>
    </>
  );
}

export default HeroSection;